module.exports = __webpack_public_path__ + "static/media/face_recognition_model.b3de953d.bin";